<template>
    <div class="card" :class="{ small: size === 'small' }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        size: {
            String,
            default: 'normal',
        },
    },
}
</script>

<style scoped lang="sass">
.card + .card
    margin-left: $m
.card
    padding: $l
    background: $neutral-black
    border-radius: 12px

    &.small
        padding: $s
</style>
